import { ReactNode, useMemo } from "react";

import { SelectTriggerButton } from "./select-trigger-button";

interface NamedOption {
  id: string;
  name: string;
}

interface SingletonSelectFieldProps<TOption extends NamedOption> {
  value: string;
  disabled?: boolean;
  optionList: TOption[];
  renderDropdown: (args: { value: string; disabled?: boolean; children: ReactNode }) => ReactNode;
}

export function SingletonSelectField<TOption extends NamedOption>({
  value,
  disabled,
  optionList,
  renderDropdown,
}: SingletonSelectFieldProps<TOption>) {
  const displayName = useMemo(() => optionList.find((option) => option.id === value)?.name ?? value, [optionList, value]);

  return renderDropdown({
    value,
    disabled,
    children: <SelectTriggerButton value={displayName} disabled={disabled} />,
  });
}
